import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ImageModalData } from "../../services/image-modal.service";

@Component({
    selector: "app-image-modal",
    templateUrl: "./image-modal.component.html",
    styleUrls: ["./image-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ImageModalComponent {
	constructor(
		public readonly dialogRef: MatDialogRef<ImageModalComponent>,
		@Inject(MAT_DIALOG_DATA) public readonly data: ImageModalData
	) {}

	public onImageError(event: Event): void {
		// Image load error handled silently for production
		const imgElement = event.target as HTMLImageElement;
		if (imgElement) {
			imgElement.style.display = "none";
		}
	}

	public close(): void {
		this.dialogRef.close();
	}
}
